<template>
<v-app style="padding-top:140px;background-color:white">
  <div style="padding-top:10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#7FB4FD" class="txt">Reviews</span></p>
     </div>
    <v-container>
    <v-layout row wrap>
        <v-flex xs12 style="text-align:right">
            <v-btn color="#e53935" depressed @click.stop="reviewDialog=true" dark class="txt_dec">
          Add a Testimonial
        </v-btn>
        </v-flex>
        <v-flex xs12 sm12 md4 v-for="item in list" :key="item.id" style="padding:5px">
            <v-card class="container" style="background-color:#eceff1">
                <p style="text-align:right">{{item.date}}</p>
                <h4 style="text-align:center">{{item.title}}</h4>
                <p>{{item.message}}</p>
            </v-card>
        </v-flex>
    </v-layout>
    </v-container>
    

    <v-dialog v-model="reviewDialog" width="700px">
        <v-card class="container">
            <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12>
                <v-text-field v-model="form.title" label="Title *" :rules="emptyRule" required></v-text-field>
                <v-textarea v-model="form.message" label="Your message *" :rules="emptyRule" required></v-textarea>
            </v-flex>
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click.stop="reviewDialog=false">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
        </v-card>
    </v-dialog>
</v-app>
</template>

<script>
import config from "./../../config.json";

export default {
  data() {
    return {
        reviewDialog: false,
      search: "",
      orderDialog: false,
      deactive: false,
      btnSave: false,
      btnSave1: false,
      address: [],
      addressDialog: false,
      valid: true,
      selectedAddress: {
        id: null,
        name: null,
        mobileNumber: null,
        address: null,
        pinCode: null
      },
      selectedAddress1: null,

      form: {
          customerName: null,
          address: null,
          title: null,
          message: null
      },


      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "REMOVE", value: "remove" }
      ],
      homePage: {
        productCategoryList: null,
      },
      list: [],
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
  },

  methods: {
    productDetail(item) {
     this.$router.push(`/productDetail/` + item.itemId);
    },
    cart(item) {
     this.$store.commit('addToCart', item);
   },
   minuscart(item) {
     this.$store.commit('minusToCart', item);
   },
    removeFromWish(item) {
        this.$store.commit('removeFromWish', item);
    },

    category(cus) {
      this.$router.push("/categoryDetail/" + cus.id);
    },
    home(){
      this.$router.push(`/demo`);
    },

    getTestimonial() {
      this.axios
        .get(config.API + "Testimonials", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          this.$Progress.finish();
          this.getTestimonial();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },

    proceed() {
      if (sessionStorage.loggedInUserID != null) {
        if(this.selectedAddress.id == null || this.selectedAddress.id == 'undefined') {
          this.addressDialog = true;
        }
        else {
          this.btnSave = true;
        this.axios
          .post(
            config.API + `Orders`,
            {
              addressId: JSON.parse(this.selectedAddress.id),
              totalPrice: JSON.parse(this.totalPrice),
              paymentType: this.selected1,
              orderDetails: this.orderDetails
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Order Successfully placed");
            this.$store.commit('count');
            this.orderDialog = true;
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
        }
      }
      else {
        this.$router.push("/login");
      }
    },

    getData() {
      if(sessionStorage.loggedInUserID != null) {
        this.axios
        .get(config.API + "CustomerAddresses/" + 1, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.selectedAddress.id = res.data.id;
          this.selectedAddress.name = res.data.name;
          this.selectedAddress.mobileNumber = res.data.mobileNumber;
          this.selectedAddress.address = res.data.address;
          this.selectedAddress.pinCode = res.data.pinCode;
        })
      }
    },

    getData1() {
      this.axios
        .get(config.API + "CustomerAddresses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.address = res.data;
        });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Testimonials`,
            {
              customerName: this.form.customerName,
              address: this.form.address,
              message: this.form.message,
              title: this.form.title
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.reviewDialog = false;
            this.btnSave = false;
            this.$refs.form.reset();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field(s) are empty!!`);
      }
    }
},

mounted() {
   this.getData();
   this.getData1();
   this.getTestimonial();

        this.axios
        .get(config.API + "States", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
        });
  },

  computed: {
    totalPrice() {
        let total = 0;

        for (let item of this.$store.state.cart) {
            total += item.totalPrice;
        }

        return total.toFixed(2);
    }
}
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>
<style>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
  margin: 0px;
}
.covid1 {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.point {
  cursor:pointer !important;
}
.bgc {
    background-color:#eeeeee !important;
}
</style>
